import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { MouseEvent, useContext } from 'react'
import { EventsContext, FilterOptions } from './EventsProvider'

interface ToolbarProps {
  onFilterChange: (filter: string) => void
}

function FilterEventsButtons({ onFilterChange }: ToolbarProps) {
  const { loadingEvents, selectedFilter, showSearchFilterButton } = useContext(EventsContext)

  const handleChange = (event: MouseEvent<HTMLElement>, newAlignment: FilterOptions) => {
    if (newAlignment !== null) {
      onFilterChange(newAlignment)
    }
  }

  return (
    <ToggleButtonGroup disabled={loadingEvents} fullWidth exclusive size="small" value={selectedFilter} onChange={handleChange}>
      <ToggleButton value="daily" sx={{ fontWeight: 'bold', borderRadius: 1 }}>
        Dagens
      </ToggleButton>
      <ToggleButton value="incident" sx={{ fontWeight: 'bold', borderRadius: 1 }}>
        Fellesfeil
      </ToggleButton>
      <ToggleButton value="planned" sx={{ fontWeight: 'bold', borderRadius: 1 }}>
        Planlagt
      </ToggleButton>
      <ToggleButton value="generic" sx={{ fontWeight: 'bold', borderRadius: 1 }}>
        Generell
      </ToggleButton>
      <ToggleButton value="all" sx={{ fontWeight: 'bold', borderRadius: 1 }}>
        Alle
      </ToggleButton>
      {showSearchFilterButton && (
        <ToggleButton value="search" sx={{ fontWeight: 'bold', borderRadius: 1 }}>
          Søk
        </ToggleButton>
      )}
    </ToggleButtonGroup>
  )
}

export default FilterEventsButtons
